<template>
  <div class="import-main">
    <Space wrap> </Space>
    <div class="header_top">
      <div class="import_btn">
        导入
        <input
          type="file"
          accept=".xls,.xlsx"
          class="upload_file"
          @change="readExcel($event)"
        />
      </div>
      <!-- <Button type="success" @click="toimage">获取图片地址</Button> -->
    </div>

    <Table :columns="columns" :data="lists" height="500" ref="tablelist"></Table>
    <div class="submit_box">
      <Poptip
        confirm
        title="是否将数据导入列表中?"
        @on-ok="onClickSubmit"
        @on-cancel="cancel"
      >
        <Button type="success">提交数据</Button>
      </Poptip>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
import XLSX from "xlsx";
import Image from "@/views/device/image.vue";

export default {
  name: "",
  components: {
    Image,
  },
  props: {
    refListTable: {
      type: Function,
    },
  },
  data() {
    return {
      columns: [
        {
          title: "序号",
          key: "no",
          minWidth: 80,
          align: "left",
          copy: true,
        },
        {
          title: "名称",
          minWidth: 180,
          align: "left",
          key: "checkDeskName",
        },
        {
          title: "电话",
          minWidth: 120,
          align: "left",
          key: "phone",
          copy: true,
        },
        {
          title: "地址",
          key: "address",
          minWidth: 160,
          align: "left",
          copy: true,
        },
        {
          title: "负责人",
          minWidth: 120,
          align: "left",
          key: "principalUser",
          copy: true,
        },

        {
          title: "是否父级",
          minWidth: 120,
          align: "left",
          key: "isParent",
          copy: true,
        },
        {
          title: "父级名称",
          minWidth: 120,
          align: "left",
          key: "parentName",
          copy: true,
        },
      ],
      lists: [],
      oldList: [],
    };
  },
  computed: {},
  created() {},
  methods: {
    readExcel(e) {
      // 读取表格文件
      let that = this;
      const files = e.target.files;
      if (files.length <= 0) {
        return false;
      } else if (!/.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$message({
          message: "上传格式不正确，请上传xls或者xlsx格式",
          type: "warning",
        });
        return false;
      } else {
        // 更新获取文件名
        that.upload_file = files[0].name;
      }
      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: "binary",
          });
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) || []; //生成json表格内容
          that.lists = [];
          console.log(ws);
          // 从解析出来的数据中提取相应的数据
          ws.forEach((item) => {
            that.lists.push({
              no: item["__rowNum__"] + 1,
              checkDeskName: item["名称"],
              phone: item["电话"],
              address: item["地址"],
              principalUser: item["负责人"],
              isParent: item["是否父级：1.是父级 2.不是父级"],
              parentName: item["父级名称"],
            });
          });
        } catch (e) {
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
      e.target.value = "";
    },
    onClickSubmit() {
      if (this.lists.length == 0) {
        this.$Modal.remove();
        return;
      }
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              style: "animation: ani-demo-spin 1s linear infinite",
              props: {
                type: "ios-loading",
                size: 18,
              },
            }),
            h("div", "Loading"),
          ]);
        },
      });
      $utils.api
        .load(`/admin/system/check/listWorkCommon`, this.lists, "POST")
        .then((res) => {
          if (res.code == 200) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            let arr = res.successTotal || 0;
            $utils.toast.success(`导入成功`);
            this.refListTable();
            this.$Spin.hide();
            this.$Modal.remove();
          }
          if (res.code == 500) {
            this.lists = res.data || [];
            this.oldList = res.data || [];
            this.$Spin.hide();
          }
        })
        .catch((e) => {
          $utils.toast.error("导入异常" + e.message);
          this.$Spin.hide();
        });
    },
    toimage() {
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "图片",
          width: 300,
          okText: "关闭",
          showOk: false,
          render: (h) => {
            return <Image style={{ margin: "0", color: "#19be6b" }}></Image>;
          },
        });
      }, 500);
    },
    //js XLSX读取 excel 转换日期格式
    getFormatDate_XLSX(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);
      var fractional_day = serial - Math.floor(serial) + 0.0000001;
      var total_seconds = Math.floor(86400 * fractional_day);
      var seconds = total_seconds % 60;
      total_seconds -= seconds;
      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;
      var d = new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
      //得到Date()对象后，便可进行日期格式化了！
      var add0 = (m) => (m < 10 ? "0" + m : m);
      var YYYY = d.getFullYear();
      var MM = add0(d.getMonth() + 1);
      var DD = add0(d.getDate());
      var hh = add0(d.getHours());
      var mm = add0(d.getMinutes());
      var ss = add0(d.getSeconds());
      return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`;
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.header_top {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
}

.import_btn {
  width: 60px;
  height: 35px;
  border-radius: 10px;
  background-color: #fb9338;
  text-align: center;
  line-height: 35px;
  position: relative;
  color: #fff;

  .upload_file {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
  }
}

.submit_box {
  // width: 100px;
  float: right;
  margin-top: 20px;
  margin-left: 15px;
}
</style>
